import SidebarLogo from "../../assets/images/sidebar_logo.png";
import SarsGSP from "../../assets/images/sars/SRAS-CoV-2_Main1.png";

export const newsItems = [

  {
    date: "2026-03-27",
    title: "PathoTrack Goes Live!",
    summary: "Official public launch of PathoTrack for genomic pathogen tracking.",
    link: "/home",
    image: SidebarLogo,
    tags: ["Launch"],
  },
  {
    date: "2022-05",
    title: "SARS-CoV-2 Genomics Surveillance Study Published in Mo Med",
    summary: `A study on SARS-CoV-2 genomics surveillance in Missouri, using integrated data analytics and visualization tools, was published in *Mo Med* (2022 May–Jun;119(3):185-187). The work supports genomic surveillance and public health response efforts in Missouri.`,
    link: "https://pubmed.ncbi.nlm.nih.gov/36035558/",
    image: null,
    tags: ["Publication", "Genomic Surveillance", "SARS-CoV-2"],
  },
  {
    date: "2022-04-07",
    title: "Presented at Nexus Informatics Conference",
    summary: `The team delivered an oral presentation at the 2022 Nexus Informatics Conference during the Data Structure session. 

    Presentation focused on platforms for SARS-CoV-2 genomics surveillance and the use of data analytics and integration portals to support public health response efforts in Missouri.`,
    link: "https://www.kcbioinformatics.org/2022-nexus-informatics-conference-agenda/",
    image: null,
    tags: ["Conference", "Presentation", "Genomics", "SARS-CoV-2"],
  },
  {
    date: "2022-03-25",
    title: "SARS-CoV-2 Genomics Surveillance Portal Launched",
    summary: "The SARS-CoV-2 Genomics Surveillance Portal provides trends in identified variants of concern (VOCs) and an interactive regional map displaying Missouri counties with the total number of sequenced samples. The platform supports real-time genomic pathogen tracking and public health monitoring.",
    link: "https://dataportals.missouri.edu/SARSCoV2",
    image: SarsGSP,
    tags: ["Launch", "Genomic Surveillance"],
  },
];